import { render } from "./BaseModalFooterComponent.vue?vue&type=template&id=3612f7c0"
const script = {}

import "./BaseModalFooterComponent.vue?vue&type=style&index=0&id=3612f7c0&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__